import { render, staticRenderFns } from "./RelearnPage.vue?vue&type=template&id=5095f2b6&scoped=true&"
import script from "./RelearnPage.vue?vue&type=script&lang=js&"
export * from "./RelearnPage.vue?vue&type=script&lang=js&"
import style0 from "./RelearnPage.vue?vue&type=style&index=0&id=5095f2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5095f2b6",
  null
  
)

export default component.exports